export default __webpack_public_path__ + "70a325d220e8fe47d7c91f635c2c3f10.png";